var _rect, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserRoles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-roles",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1301",
    transform: "translate(9.059 9.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M15.447,15.246a2.671,2.671,0,0,1-2.005-.8,2.844,2.844,0,0,1-.78-2.067,2.844,2.844,0,0,1,.78-2.067,2.671,2.671,0,0,1,2.005-.8,2.671,2.671,0,0,1,2.005.8,2.844,2.844,0,0,1,.78,2.067,2.844,2.844,0,0,1-.78,2.067A2.671,2.671,0,0,1,15.447,15.246ZM9.506,21.389v-1.8a2.152,2.152,0,0,1,.353-1.244,2.283,2.283,0,0,1,.91-.785,13.68,13.68,0,0,1,2.386-.861,9.373,9.373,0,0,1,2.293-.287,8.98,8.98,0,0,1,2.284.3,15.5,15.5,0,0,1,2.377.851,2.254,2.254,0,0,1,.928.785,2.152,2.152,0,0,1,.353,1.244v1.8Zm1.114-1.148h9.655V19.59a1.071,1.071,0,0,0-.176-.584,1.131,1.131,0,0,0-.436-.411,9.669,9.669,0,0,0-2.172-.813,9.331,9.331,0,0,0-2.042-.22,9.585,9.585,0,0,0-2.061.22,9.25,9.25,0,0,0-2.172.813,1.068,1.068,0,0,0-.427.411,1.114,1.114,0,0,0-.167.584ZM15.447,14.1a1.6,1.6,0,0,0,1.2-.488,1.845,1.845,0,0,0,0-2.468,1.713,1.713,0,0,0-2.4,0,1.845,1.845,0,0,0,0,2.468A1.6,1.6,0,0,0,15.447,14.1ZM15.447,12.376ZM15.447,20.241Z",
    transform: "translate(-9.506 -9.506)",
    fill: "rgba(0,0,0,0.6)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path5502",
    d: "M0,0Z",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1393",
    transform: "translate(2.496 2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1966",
    d: "M12.112,4.114a11.124,11.124,0,0,0-8,8c.069-.005.138-.011.208-.011a2.751,2.751,0,0,1,.88.147A10.038,10.038,0,0,1,12.247,5.2a2.749,2.749,0,0,1-.147-.879C12.1,4.251,12.107,4.183,12.112,4.114Zm5.537,0c.005.069.01.137.01.207a2.752,2.752,0,0,1-.145.878,10.033,10.033,0,0,1,7.046,7.049,2.749,2.749,0,0,1,.879-.147c.07,0,.139,0,.207.01a11.149,11.149,0,0,0-8-8ZM5.2,17.512a2.749,2.749,0,0,1-.879.147c-.07,0-.139,0-.207-.01a11.149,11.149,0,0,0,8,8c-.005-.069-.01-.137-.01-.207a2.752,2.752,0,0,1,.145-.878A10.033,10.033,0,0,1,5.2,17.512Zm19.359,0a10.032,10.032,0,0,1-7.046,7.049,2.752,2.752,0,0,1,.145.878c0,.07,0,.139-.01.207a11.149,11.149,0,0,0,8-8c-.069.005-.137.01-.207.01a2.749,2.749,0,0,1-.879-.147Z",
    transform: "translate(-2.376 -2.376)",
    fill: "rgba(0,0,0,0.6)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g7328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7306",
    transform: "translate(10.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7304",
    d: "M29.954,3.341A1.945,1.945,0,1,0,31.9,5.286,1.95,1.95,0,0,0,29.954,3.341Z",
    transform: "translate(-28.008 -3.341)",
    fill: "rgba(0,0,0,0.6)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7310",
    transform: "translate(10.559 21.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7308",
    d: "M17.505.76A1.945,1.945,0,1,0,19.45,2.7,1.95,1.95,0,0,0,17.505.76Z",
    transform: "translate(-15.56 -0.76)",
    fill: "rgba(0,0,0,0.6)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7314",
    transform: "translate(0 10.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7312",
    d: "M17.505.76A1.945,1.945,0,1,0,19.45,2.7,1.95,1.95,0,0,0,17.505.76Z",
    transform: "translate(-15.56 -0.76)",
    fill: "rgba(0,0,0,0.6)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7318",
    transform: "translate(21.118 10.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7316",
    d: "M17.505.76A1.945,1.945,0,1,0,19.45,2.7,1.95,1.95,0,0,0,17.505.76Z",
    transform: "translate(-15.56 -0.76)",
    fill: "rgba(0,0,0,0.6)",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoles);
export default __webpack_public_path__ + "static/media/User-roles.cb37cfebed777a2748f6d51398ac8041.svg";
export { ForwardRef as ReactComponent };